import { Home } from "@intocare/interfaces";

import * as homes from "../actions/homes.data";

export interface State {
	homes: Home[];
}

export const initialState: State = {
	homes: [],
};

export function reducer(state = initialState, action: homes.Actions): State {
	switch (action.type) {
		case homes.SET_HOMES:
			return {
				...state,
				homes: action.payload.data,
			};
		case homes.UPDATE_HOME: {
			const index = state.homes.findIndex((h) => h.id === action.payload.data.id);

			return {
				...state,
				homes: [...state.homes.slice(0, index), { ...action.payload.data }, ...state.homes.slice(index + 1)],
			};
		}
		case homes.UPDATE_HOME_PHARMACIES: {
			const licenseNumber = action.payload.data.licenseNumber;
			const index = state.homes.findIndex((h) => h.id === action.payload.data.id);
			const home = { ...state.homes[index] };
			const pharmaciesSet = new Set(home.pharmacies || []);

			if (pharmaciesSet.has(licenseNumber)) {
				pharmaciesSet.delete(licenseNumber);
			} else {
				pharmaciesSet.add(licenseNumber);
			}

			home.pharmacies = Array.from(pharmaciesSet);

			return {
				...state,
				homes: [...state.homes.slice(0, index), { ...home }, ...state.homes.slice(index + 1)],
			};
		}
		default:
			return state;
	}
}

export const getHomes = (state: State) => state.homes;
